module.exports = __webpack_public_path__ + "static/media/city.6aaf8a87.svg";